export default "__VITE_ASSET__DJ99E6_z__"